import { isProduction } from '@src/constants';
import qs from '@src/utils/query-string-util';

/**
 * Reads the simulated login identity from the non-master URL query `?_mock_passport_account=<full-account>`.
 *
 * The value must be a full account (e.g. 18615625506): the backend resolves only complete accounts,
 * while the XPASS runtime only exposes masked accounts (e.g. 159***520) it cannot recognize — which
 * is why an earlier attempt reading `window.XPASS.u_account` never took effect. Core-domain public
 * endpoints (get_servers/get_roles) accept this parameter as a login substitute; it was verified on
 * 2026-09-09 that get_roles returns the account's roles with it, and get_servers ignores it.
 *
 * Two consumers share this source: the ZT/JXSJ4 service factories inject it into request params, and
 * the `src/initialize/mock-passport-account` startup task writes it into `window.XPASS.u_account`
 * before rendering, so frontend login state and request identity stay under the same parameter.
 *
 * @returns {string|undefined} The full simulated account, or undefined on master / absent / empty values.
 */
export function getMockPassportAccount() {
  if (isProduction) {
    return undefined;
  }

  const mockPassportAccount = qs.getSearchParams()['_mock_passport_account'];
  return typeof mockPassportAccount === 'string' && mockPassportAccount ? mockPassportAccount : undefined;
}
